import Image from "next/image";
import dayjs from "dayjs";
import { FiAlertCircle } from "react-icons/fi";

import closeIcon from "assets/icons/close_blue.svg";

import styles from "./index.module.scss";

type Props = {
  label: string;
  allList: any[]; //TODO: とりあえず
  selected: string | number;
  changeCheck: (value: string) => void;
  disabled?: boolean | "";
};

/* フィルター */
const ListFilter: React.FC<Props> = ({
  label,
  allList,
  selected,
  changeCheck,
  disabled
}) => {
  // selectedの値がallListに存在しないことを確認する
  const isSelectedNotExist = allList.every((item) => item.id !== selected);

  return (
    <div
      className={
        selected ? styles.filter_container_active : styles.filter_container
      }
    >
      <div className={styles.filter_label}>
        {selected
          ? allList.find((item) => item.id === selected)?.name
          : `${label}`}
        {/* 対象月のフィルタで指定された年月のデータが存在しない時に年月を表示だけする */}
        {/* ユースケース：ダッシュボードからの遷移時 */}
        {selected &&
          label === "対象月" &&
          isSelectedNotExist &&
          dayjs().format("YYYY年MM月")}
        {allList.find((item) => item.id === selected)?.name ===
          "異常箇所あり" && <FiAlertCircle color="#ef5350" />}
      </div>
      <select
        className={styles.filter}
        name="filter"
        value={selected}
        onChange={(e) => changeCheck(e.target.value)}
        disabled={disabled || false}
      >
        <option value="">全選択</option>
        {allList.map((item, i) => (
          <option
            value={item.id}
            key={label + i + item.id}
            disabled={item.id === "explain_text"}
          >
            {item.name}
          </option>
        ))}
      </select>
      <div
        className={selected && !disabled ? styles.unfilter : styles.hidden}
        onClick={(e) => {
          e.stopPropagation;
          changeCheck("");
        }}
      >
        <Image src={closeIcon} alt="フィルターを外す" />
      </div>
    </div>
  );
};

export default ListFilter;
